import { FunctionalComponent } from 'preact'
import { IdeaStatus } from '../../../control-components/ideation-status/Types'
import Phrase from '../../../libs/translationsUtils/phrase'
import IdeationListItem, { IdeationListItemProps } from './IdeationListItem'

export interface IdeationFiltersBoxProps extends Omit<IdeationListItemProps, 'name'> {
  ideationStatuses: IdeaStatus[]
}

const IdeationFiltersBox: FunctionalComponent<IdeationFiltersBoxProps> = ({
  className,
  selectedName,
  onSelect,
  ideationStatuses
}) => (
  <div className={className}>
    <h3 className='widget-title'>
      <Phrase p='filter.by.idea.status' />
    </h3>
    <ul className='ideation-filters__idea-status'>
      <IdeationListItem selectedName={selectedName} name={null} onSelect={onSelect} />
      {ideationStatuses.map(({ name }, index) => (
        <IdeationListItem key={index} selectedName={selectedName} name={name} onSelect={onSelect} />
      ))}
    </ul>
  </div>
)

export default IdeationFiltersBox
